<template>
  <b-container fluid>
    <b-container>
      <div class="page-title">
        <h4>سبد خرید</h4>
      </div>

      <b-row v-if="isEmpty">
        <div class="empty-cart">
          <img alt="shopping cart" class="mt-3" :src="EmptyCartImage"/>
          <h4>سبد خرید شما خالی است!</h4>
        </div>
      </b-row>

      <b-row class="mt-3" v-else>
        <b-col class="mb-3" xl="9" lg="8" md="12" sm="12">
          <div class="border border-1 p-3 shadow ">
            <basket-item-row
                v-for="item in items"
                :item="item"
                :key="item.id"
                :orderId="item.id"
                :basketId="sidebarData.id"
                :itemCount="item.quantity"
                :deleteFunction="removeItem"
            />
          </div>
        </b-col>

        <b-col xl="3" lg="4" md="12" sm="12">
          <basket-sidebar
              :items="items"
              :sidebarData="sidebarData"
              :deliveryPrice="deliveryPrice"
              :deliveryBoundary="deliveryBoundary"
              :submit="onSubmit"
              :caption="sideBarContinueText"
          />
          <div class="text-center">
            <span class="attention">حداقل خرید برای ارسال رایگان </span>
            <span class="attention">{{ formatNumber(deliveryBoundary) }}</span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import router from "@/router";
import store from "@/store";
import {mapGetters, mapActions} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter"
import BasketItemRow from "./ItemRow.vue";
import BasketSidebar from "./Sidebar.vue";

export default {
  name: "ShoppingCard",
  components: {BasketItemRow, BasketSidebar},
  props: {
    EmptyCartImage: {
      type: String,
      default: require('../../../assets/empty-cart.svg')
    },
    sideBarContinueText: {
      default: "ادامه فرایند خرید"
    }
  },
  data() {
    return {};
  },
  methods: {
    formatNumber,
    ...mapActions({
      removeAll: "ShoppingCart/removeAll",
    }),
    onSubmit() {
      // if all of the products was digital we stright to the payment page
      let havePysicalProducts = false;
      this.items.forEach(item => {
        if (item.product.is_digital == 0) {
          havePysicalProducts = true;
        }
      });

      if (havePysicalProducts) {
        router.push({name: "Delivery"});
      } else {
        router.push({name: "Payment"});
      }
    },
    removeItem(e) {
      console.log(e);
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let products = []
        let formData = new FormData();

        let counter = 0;

        Object.keys(productsJson).forEach(function (key) {

          products.push({
            id: productsJson[key]['id'],
            sub_product: productsJson[key]['sub_product_id']
          })

          formData.append(`product[${counter}][id]`,productsJson[key]['id'])
          if(productsJson[key]['sub_product_id']>0){
            formData.append(`product[${counter}][sub_product]`,productsJson[key]['sub_product_id'])
          }



          counter += 1;

        })
        await store.dispatch("ShoppingCart/addItem", formData)
        localStorage.removeItem('products')
      }
    }
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderUnpaidItems",
      sidebarData: "ShoppingCart/getSidebarBasketData",
      order: "ShoppingCart/getItems",
      deliveryBoundary: "ShoppingCart/getDeliveryBoundary",
      deliveryPrice: "ShoppingCart/getDeliveryPrice"
    }),
    isEmpty() {
      return this.items.length == 0;
    },
  },
  async mounted() {
    await this.getUnAuthBasketItems();
    await this.$store.dispatch("ShoppingCart/userOrderUnpaid")

  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid lightgray;
}

.page-title h4 {
  height: 100%;
  width: 120px;
  text-align: center;
  color: var(--dark);
  font-size: 18px;
  line-height: 1;
  padding-bottom: 5px;
  margin-bottom: 0;
  border-bottom: 3px solid var(--primary);
}

.empty-cart {
  font-size: 14px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.attention {
  font-size: 12px;
}

</style>